import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';

export interface UserBillingData {
  vat: string;
  isVatVerified: boolean;
  company: string;
  countryCode: string;
  city: string;
  state: string;
  zip: string;
  address: string;
  address2: string;
}

const getBillingInformation = (makeCall: MakeCall) => (userId: number) =>
  makeCall<UserBillingData>(
    'GET',
    `${APIV2_URL}/user/${userId}/billing-data`,
  ).then(res => ({
    ...res,
    data: {
      ...res.data,
      countryCode: (res.data.countryCode || '').toUpperCase(),
    },
  }));

export default getBillingInformation;
